import React, { Component, useEffect, useState } from 'react';
import configData from '../configData.json';
import Spinner from 'react-bootstrap/Spinner';
import Select from 'react-select';
import { toDate } from 'date-fns';
import SelectSearch, { fuzzySearch } from "react-select-search";
import DatePicker from 'react-date-picker';
import moment from 'moment';

import "../style/select-search.css";
import { isDisabled } from '@testing-library/user-event/dist/utils';

export default function ForecastRightFilterContent(props) {

    const [toDate, setToDate] = useState(new Date());
    const [fromDate, setFromDate] = useState(new Date(toDate.getFullYear(), 0, 1, 23, 59, 59));
    const defaultFromValue = moment(fromDate).format().substring(0, 10);
    const defaultToValue = moment(toDate).format().substring(0, 10);

    const [owners, setOwners] = useState([]);
    const [customers, setCustomers] = useState([]);
    const [divisions, setDivision] = useState([{ value: "0", name: "-- Select A Value --" }]);
    const [selectedOwner, setSelectedOwner] = useState(0);
    const [selectedCust, setSelectedCust] = useState(0);
    const [selectedDivision, setSelectedDivision] = useState(0);
    const [selectedProNumber, setSelectedFb] = useState('');
    const [selectedAccountNumber, setSelectedAccountNumber] = useState('');
    const [selectedFromDate, setSelectedFromDate] = useState(moment(fromDate).format().substring(0, 10));
    const [selectedToDate, setSelectedToDate] = useState(moment(toDate).format().substring(0, 10));
    const [ownerLoading, isOwnerLoading] = useState(false);
    const [customerLoading, isCustomerLoading] = useState(false);
    const [divisionLoading, isDivisionLoading] = useState(false);



    const [selectedPastNumOfWeek, setSelectedPastNumOfWeek] = useState(20);
    const [selectedImmediatePastNumWeek, setSelectedImmediatePastNumWeek] = useState(3);
    const [selectedPercentageDecrease, setSelectedPercentageDecrease] = useState(20);
    const [selectedPercentageIncrease, setSelectedPercentageIncrease] = useState(20);

    const [selectedAccountNumberWithNoInvoice, setAccountNumberWithNoInvoice] = useState(false);

    const LoadOwners = async () => {
        // debugger;
        isOwnerLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Owner/GetOwnerList`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let ownerOptions = [];
                resp.map(owner => {
                    const own = {
                        "name": owner.ownerName,
                        "value": owner.ownerID
                    }
                    ownerOptions = [...ownerOptions, own];
                })
                const defaultOwner = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                ownerOptions.unshift(defaultOwner);
                setOwners(ownerOptions)
            })
        isOwnerLoading(false);
        LoadCustomer(0);
        LoadDivision(0);

        // setIsDisabled(props.isDisabled);
    }

    const LoadCustomer = async (ownerKey) => {
        // debugger;
        setSelectedOwner(ownerKey);
        isDivisionLoading(true);
        const custUrl = `${configData.BASE_APP_URL}Customer/GetCustomerList/${ownerKey}`;
        await fetch(custUrl,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            }
        ).then(resp => resp.json())
            .then(resp => {
                let customerOptions = [];
                resp.map(customer => {
                    const cust = {
                        "name": customer.customerName,
                        "value": customer.customerKey
                    }
                    customerOptions = [...customerOptions, cust];
                })
                const defaultCustomer = {
                    "name": "--Select A Value--",
                    "value": 0
                }
                customerOptions.unshift(defaultCustomer);
                setCustomers(customerOptions)
            })
        isDivisionLoading(false);
        // setIsDisabled(props.isDisabled);
    }

    const LoadDivision = async (customerKey) => {
        debugger;
        isDivisionLoading(true);
        setSelectedCust(customerKey);
        const URL = `${configData.BASE_APP_URL}Division/GetDivisionList/${customerKey}`;
        await fetch(URL,
            {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': sessionStorage.getItem('my-token')
                }
            })
            .then(resp => resp.json())
            .then(resp => {
                let divisionOptions = [];
                resp.map((division) => {
                    const carr = {
                        "name": division.divisionName,
                        "value": division.divisionKey
                    }
                    divisionOptions = [...divisionOptions, carr];

                })
                // const defaultCarrier = {
                //     "name": "-- Select A Value --",
                //     "value": -1
                // }
                // carrierOptions.unshift(defaultCarrier);
                if (customerKey > 0) {
                    const allDivision = {
                        "name": "-- ALL DIVISIONS  --",
                        "value": 0
                    }
                    divisionOptions.unshift(allDivision);
                }
                else {
                    const defaultDivision = {
                        "name": "-- Select A Value --",
                        "value": 0
                    }
                    divisionOptions.unshift(defaultDivision);
                }
                setDivision(divisionOptions)
            })
        isDivisionLoading(false);
    }

    const LoadBills = async (e) => {
        debugger;
        e.preventDefault();
        if (selectedOwner === 0) {
            document.getElementById("owner-error").innerHTML = "Owner is a Required Field, a selection must be made";
            return;
        }
        else {
            document.getElementById("owner-error").innerHTML = "";
        }

        if (selectedCust === 0) {
            document.getElementById("customer-error").innerHTML = "Customer is a Required Field, a selection must be made";
            return;
        }
        else {
            document.getElementById("customer-error").innerHTML = "";
        }

        props.onSearchClick(selectedCust, selectedPastNumOfWeek, selectedImmediatePastNumWeek, selectedPercentageDecrease, selectedPercentageIncrease, selectedDivision);
    }

    useEffect(() => {
        debugger;
        LoadOwners();
        // LoadCustomer();
        // const inputPstNoOfwk = document.querySelector('#pastnumofweek');
    }, [])

    const onOwnerSelect = (e) => {
        // debugger;
        var ownerkey = e;
        if (ownerkey > 0) {
            document.getElementById("owner-error").innerHTML = "";
        }
        LoadCustomer(e);
        LoadDivision(0)
        setSelectedCust(0);
        setSelectedDivision(0);
        // props.onCustomerChange(custkey);

    };

    const onCustomerSelect = (e) => {
        var custkey = e;
        if (custkey > 0) {
            document.getElementById("customer-error").innerHTML = "";
        }
        LoadDivision(e);
        setSelectedDivision(0);
    };

    const onDivisionSelect = (e) => {
        setSelectedDivision(e);
    };

    const ClearFilter = async (e) => {
        // debugger;
        e.preventDefault();
        setSelectedOwner(0);
        setSelectedCust(0);
        setSelectedDivision(0);

        let customerOptions = [];
        const defaultCustomer = {
            "name": "-- Select A Value --",
            "value": 0
        }
        customerOptions.unshift(defaultCustomer);
        setCustomers(customerOptions);

        let divisionOptions = [];
        const defaultDivision = {
            "name": "-- Select A Value --",
            "value": 0
        }
        divisionOptions.unshift(defaultDivision);
        setDivision(divisionOptions);
    }

    const clickOnCheckBox = () => {
        props.onCheckboxClick()
        if (selectedAccountNumberWithNoInvoice == false) {
            setAccountNumberWithNoInvoice(true)
        }
        else {
            setAccountNumberWithNoInvoice(false)
        }
    };



    return (
        <>
            <div className="mb-2 form-field">
                <div id="owner-error" className="text-danger"></div>
                <label>Owner</label>
                <label id="owner-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnOwner"
                        name="ddnOwner"
                        // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                        value={selectedOwner}
                        options={owners}
                        onChange={onOwnerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {ownerLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : ownerLoading}
            </div>
            <div className="mb-3 form-field">
                <div id="customer-error" className="text-danger"></div>
                <label>Customer</label>
                <label id="customer-highlight" className="text-danger">*</label>
                <div>
                    <SelectSearch
                        id="ddnCustomer"
                        name="ddnCustomer"
                        // value={props.topFilterCustKey != '' ? props.topFilterCustKey : selectedCust}
                        value={selectedCust}
                        options={customers}
                        onChange={onCustomerSelect}
                        search
                        filterOptions={fuzzySearch}

                    >
                    </SelectSearch>
                </div>
                {divisionLoading ? <Spinner className='spinner-border spinner-border-custom' animation="border" variant="primary" /> : divisionLoading}
            </div>
            <div className="mb-2 form-field">
                <label>Division</label>
                <div>
                    <SelectSearch
                        id="ddnDivision"
                        name="ddnDivision"
                        value={selectedDivision}
                        options={divisions}
                        onChange={onDivisionSelect}
                        search
                        filterOptions={fuzzySearch}
                    >
                    </SelectSearch>
                </div>
            </div>
            <div className="mb-3 form-check" hidden={props.isCheckBoxHidden}>
                <input id='myCheckbox' className='form-check-input' type='checkbox' onChange={clickOnCheckBox} checked={selectedAccountNumberWithNoInvoice}  />
                <label>Account Numbers with No Invoice</label>
            </div>
            <div className="form-field mx-auto" style={{ width: "180px" }}>
                <button type="button" onClick={ClearFilter} className='btn btn-clear'>Clear</button>
                <button type="button" onClick={LoadBills} className='btn btn-filter ms-2'>Filter</button>
            </div>
        </>
    )
}
